import { Brand } from '@ui/brand';
import { Avatar, Button } from '@heroui/react';
import { ArrowLeft2, Location } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';

export const MobileNavItems = ({
  place = 'Алматы',
  title = 'Главная страница',
  subtitle,
  onPress,
  type = 'primary',
  isBack,
}: {
  title?: string;
  subtitle?: string;
  place?: string;
  type?: 'primary' | 'secondary' | 'none' | 'search';
  onPress?: () => void;
  isBack?: boolean;
}) => {
  const navigate = useNavigate();

  if (type === 'none') return null;
  if (type === 'search') {
    return (
      <>
        <div className="w-full h-[68px]" />
      </>
    );
  }
  if (type === 'secondary') {
    return (
      <>
        <div
          className={`flex h-[50px] gap-x-4
          bg-white fixed top-0 left-0 right-0 z-10 border-b px-4
            items-center ${isBack ? '-ml-4' : ''}`}
        >
          {isBack && (
            <Button isIconOnly variant="light" onPress={() => {
              navigate(-1);
              console.log('navigate -1');
            }}>
              <ArrowLeft2 size="24" color="#222222" />
            </Button>
          )}

          <div>
            <p className="text-[#222223] font-medium">{title}</p>
            {subtitle && <p className="text-[#6B767F] text-xs">{subtitle}</p>}
          </div>
        </div>
        <div className="w-full h-[50px]" />
      </>
    );
  }
  return (
    <>
      <div className="w-full flex h-[60px] bg-white fixed top-0 left-0 right-0 z-10 border-b px-4">
        <div className="py-3.5 flex items-center justify-between w-full">
          <div className="h-8 w-20">
            <Brand />
          </div>

          <Button
            variant="light"
            className="-mr-4 text-[#222222] font-semibold"
            endContent={
              <Avatar
                className="bg-[#F5F5F5]"
                showFallback
                fallback={<Location size="16" color="#006FEE" />}
                radius="md"
                size="sm"
              />
            }
            onPress={onPress}
          >
            {place}
          </Button>
        </div>
      </div>
      <div className="w-full h-[60px]" />
    </>
  );
};
